import type { UserFields } from '@dynamic-labs/sdk-api-core';

import { BaseError } from './base';

type MissingUserVerificationErrorParams = {
  informationToVerify: Extract<keyof UserFields, 'email' | 'phoneNumber'>;
  message?: string;
};

export class MissingUserVerificationError extends BaseError {
  public readonly informationToVerify: MissingUserVerificationErrorParams['informationToVerify'];

  constructor({
    informationToVerify,
    message,
  }: MissingUserVerificationErrorParams) {
    super({
      cause: null,
      code: 'missing_user_verification_error',
      docsUrl: null,
      name: 'MissingUserVerificationError',
      shortMessage:
        message ??
        `The user is missing verification for ${informationToVerify}. Please verify the user's ${informationToVerify}`,
    });

    this.informationToVerify = informationToVerify;
  }
}
